export default "__VITE_ASSET__DqIyfc07__"